export const ADDITIONAL_NAVIGATION = {
  "/pagalba-ukrainai/savanoryste": [
    {
      pathname: `/pagalba-ukrainai/aukojimas`,
      title: `Aukojimas`,
    },
  ],
  "/pagalba-ukrainai/aukojimas": [
    {
      pathname: `/pagalba-ukrainai/savanoryste`,
      title: `Savanorystė`,
    },
  ],
  "/ua/dopomoha/pozhertvy": [
    {
      pathname: `/ua/dopomoha/volonterstvo`,
      title: `Волонтерство`,
    },
  ],
  "/ua/dopomoha/volonterstvo": [
    {
      pathname: `/ua/dopomoha/pozhertvy`,
      title: `Пожертви`,
    },
  ],
  "/en/help/donation": [
    {
      pathname: `/en/help/volunteering`,
      title: `Volunteering`,
    },
  ],
  "/en/help/volunteering": [
    {
      pathname: `/en/help/donation`,
      title: `Donation`,
    },
  ],
};
